"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const web3_1 = __importDefault(require("web3"));
const bifi_currency_1 = __importDefault(require("@bifrost-platform/bifi-currency"));
const bifrost_number_1 = __importDefault(require("@bifrost-platform/bifrost-number"));
const config_1 = __importDefault(require("./config"));
const components_1 = __importDefault(require("./components"));
const CallRpc_1 = __importDefault(require("./plugin/CallRpc"));
const DexRpc_1 = __importDefault(require("./plugin/DexRpc"));
class BiFi {
    constructor(network = config_1.default.default.network, providerConfig) {
        this.components = [];
        this.initializeComponents();
        this.currency = new bifi_currency_1.default([], 'usd');
        this.callRpc = new CallRpc_1.default(network, providerConfig);
        this.uniswapRpc = new DexRpc_1.default(config_1.default.default.host.uniswap);
        this.sushiswapRpc = new DexRpc_1.default(config_1.default.default.host.sushiswap);
        this.initializeCurrency();
    }
    initializeComponents() {
        for (const component of components_1.default) {
            this.components.push(new component());
        }
    }
    initializeCurrency() {
        for (const token of this.getCurrenctNetwork().tokens) {
            if (!token.isComingSoon) {
                this.currency.setToken(token.id, new bifrost_number_1.default('0'), new bifrost_number_1.default(token.isToken ? '0' : '18'), token.address, token.name, token.name, (token.replaceString || '').replace('{}', '').trim(), token.replaceString, token.image, '#efefef');
            }
        }
    }
    setNetwork(network = config_1.default.default.network) {
        this.callRpc.setNetwork(BiFi.parseNetwork(network));
        this.initializeCurrency();
    }
    setProvider(providerConfig) {
        this.callRpc.setProvider(providerConfig);
    }
    getComponents() { return this.components; }
    getComponent(id) { return this.getComponents().find(component => component.id === id); }
    getConfig() { return config_1.default; }
    getNetworks() { return config_1.default.networks; }
    getNetwork(id = config_1.default.default.network) { return this.getNetworks().find(network => network.id === id); }
    getCurrenctNetwork() {
        const networkID = this.callRpc.getNetwork();
        return this.getNetworks().find(network => network.id === (networkID || config_1.default.default.network));
    }
    getCurrenctNetworkID() { return this.callRpc.getNetwork(); }
    getBiFiTokens() { return this.getCurrenctNetwork().tokens.filter(token => token.entryPointID === 'bifi'); }
    getElseTokens() { return this.getCurrenctNetwork().tokens.filter(token => token.entryPointID !== 'bifi'); }
    getComingSoonTokens() { return this.getCurrenctNetwork().tokens.filter(token => !!token.isComingSoon); }
    getToken(id) { return this.getCurrenctNetwork().getToken(id); }
    getTokenByAddress(address) { return this.getCurrenctNetwork().getTokenByAddress(address); }
    getTokenEntryPointID(id) { return this.getCurrenctNetwork().getTokenEntryPointID(id); }
    getTokenHandlerID(id) { return this.getCurrenctNetwork().getTokenHandlerID(id); }
    getTokenAddress(id) { return this.getCurrenctNetwork().getTokenAddress(id); }
    getTokenIsToken(id) { return this.getCurrenctNetwork().getTokenIsToken(id); }
    getTokenIsComingSoon(id) { return this.getCurrenctNetwork().getTokenIsComingSoon(id); }
    getTokenPairTokens(id) { return this.getCurrenctNetwork().getTokenPairTokens(id); }
    getTokenReplaceString(id) { return this.getCurrenctNetwork().getTokenReplaceString(id); }
    getTokenImage(id) { return this.getCurrenctNetwork().getTokenImage(id); }
    getTokenFullImage(id) { return this.getCurrenctNetwork().getTokenFullImage(id); }
    getTokenByHandlerID(id) { return this.getCurrenctNetwork().getTokenByHandlerID(id); }
    getTokenAddressByHandlerID(id) { return this.getCurrenctNetwork().getTokenAddressByHandlerID(id); }
    getHandler(id) { return this.getCurrenctNetwork().getHandler(id); }
    getHandlerTokenID(id) { return this.getCurrenctNetwork().getHandlerTokenID(id); }
    getHandlerByTokenID(id) { return this.getCurrenctNetwork().getHandlerByTokenID(id); }
    getMethod(id) { return this.getCurrenctNetwork().getMethod(id); }
    getMethodSignature(id) { return this.getCurrenctNetwork().getMethodSignature(id); }
    getMethodOutputTypes(id) { return this.getCurrenctNetwork().getMethodOutputTypes(id); }
    getEntryPoint(id) { return this.getCurrenctNetwork().getEntryPoint(id); }
    getEntryPointAddress(id) { return this.getCurrenctNetwork().getEntryPointAddress(id); }
    getBlockTerm() { return this.getCurrenctNetwork().getBlockTerm(); }
    getTokenPrice(id) { return this.currency.getToken(id).price.toStr(); }
    getTokenDecimals(id) { return this.currency.getToken(id).price.toNum(); }
    call(id, userAddress, argObject = {}) {
        return new Promise(async (resolve, reject) => {
            const startNetwork = this.getCurrenctNetworkID();
            try {
                if (!id) {
                    reject(new Error('Require call component id'));
                    return;
                }
                const component = this.getComponent(id);
                if (!component) {
                    reject(new Error(`Require valid call component id [${id}]`));
                    return;
                }
                const entryPointAddress = this.getCurrenctNetwork().getEntryPointAddress(component.entryPointID);
                const methodProps = component.getMethodProps();
                const cacheArgs = {};
                let responses = [];
                const isValidAddress = BiFi.isValidAddress(userAddress);
                if (!isValidAddress) {
                    userAddress = config_1.default.default.address.call;
                }
                if (component.requireLevel === config_1.default.REQUIRE_LEVEL.COMPLETELY && !isValidAddress) {
                    responses = methodProps.map(() => []);
                }
                else {
                    for (const methodProp of methodProps) {
                        const splitedMethodIDs = (methodProp.methodID || '').split('.');
                        let response = [];
                        if (splitedMethodIDs.length >= 1 && splitedMethodIDs[0] === 'util') {
                            const slicedMethodIDs = splitedMethodIDs.slice(1);
                            response = await this.proccessCallUtil(startNetwork, userAddress, slicedMethodIDs);
                        }
                        else {
                            const method = this.getMethod(methodProp.methodID);
                            if (method) {
                                const args = [];
                                for (const input of method.inputs) {
                                    let arg;
                                    switch (input) {
                                        case 'user.address':
                                            arg = userAddress;
                                            break;
                                        default:
                                            const methodArgument = methodProp.methodArguments.find(argument => argument.id === input);
                                            if (!methodArgument) {
                                                arg = (argObject || {})[input];
                                            }
                                            else if (cacheArgs[methodArgument.valueID]) {
                                                arg = cacheArgs[methodArgument.valueID];
                                            }
                                            else {
                                                const splitedValueIDs = (methodArgument.valueID || '').split('.');
                                                if (splitedValueIDs.length > 1) {
                                                    if (!cacheArgs[splitedValueIDs[0]]) {
                                                        cacheArgs[splitedValueIDs[0]] = await this.getMethodArgumentValue(splitedValueIDs[0]);
                                                    }
                                                    const localValue = cacheArgs[splitedValueIDs[0]];
                                                    const slicedValueIDs = splitedValueIDs.slice(1);
                                                    cacheArgs[methodArgument.valueID] = this.getMethodArgumentAppendValue(localValue, slicedValueIDs);
                                                }
                                                else {
                                                    if ((argObject || {})[methodArgument.valueID]) {
                                                        cacheArgs[methodArgument.valueID] = (argObject || {})[methodArgument.valueID];
                                                    }
                                                    else {
                                                        cacheArgs[methodArgument.valueID] = await this.getMethodArgumentValue(methodArgument.valueID);
                                                    }
                                                }
                                                arg = cacheArgs[methodArgument.valueID];
                                            }
                                            break;
                                    }
                                    args.push(arg);
                                }
                                const methodEntryPointAddress = this.getCurrenctNetwork().getEntryPointAddress(methodProp.entryPointID) || entryPointAddress;
                                response = await this.callRpc.call(startNetwork, userAddress, methodEntryPointAddress, method, args);
                            }
                        }
                        responses.push(response);
                    }
                }
                const result = component.proccessCallResponse(responses, isValidAddress, this.getCurrenctNetwork(), this.currency, argObject, cacheArgs);
                resolve(result);
            }
            catch (error) {
                if (error === config_1.default.code.diffNetwork) {
                    reject({
                        code: error,
                        message: 'The network was changed during the call processing.'
                    });
                }
                else if (error === config_1.default.code.noResponse) {
                    reject({
                        code: error,
                        message: 'Received an empty data response.'
                    });
                }
                else {
                    reject(error);
                }
            }
        });
    }
    proccessCallUtil(startNetwork, userAddress, args) {
        return new Promise(async (resolve, reject) => {
            try {
                const result = [];
                for (const arg of args) {
                    switch (arg) {
                        case 'syncTokens':
                            const network = this.getCurrenctNetwork();
                            const method = network.getMethod('bifi.market');
                            const entryPointAddress = network.getEntryPointAddress('bifi');
                            result.push(await this.syncTokens(userAddress, method, entryPointAddress, startNetwork));
                            break;
                        default:
                            result.push(false);
                            break;
                    }
                }
                resolve(result);
            }
            catch (error) {
                reject(error);
            }
        });
    }
    syncTokens(userAddress, method, entryPointAddress, startNetwork) {
        return new Promise(async (resolve) => {
            try {
                if (typeof startNetwork !== 'string') {
                    startNetwork = this.getCurrenctNetworkID();
                }
                const defaultDecimals = new bifrost_number_1.default('10').pow(config_1.default.default.decimals);
                const rawTokens = (await this.callRpc.call(startNetwork, userAddress, entryPointAddress, method, []) || [])[0] || [];
                const network = this.getCurrenctNetwork();
                const marketTokens = [];
                for (const rawToken of rawTokens) {
                    const handlerID = parseInt(rawToken[0] || 0);
                    const address = rawToken[1] || config_1.default.default.address.empty;
                    const price = new bifrost_number_1.default(rawToken[2] || '0').div(defaultDecimals).toStr();
                    const token = network.getTokenByHandlerID(handlerID);
                    if (token && token.id) {
                        this.currency.setTokenPrice(token.id, new bifrost_number_1.default(price));
                        const currencyToken = this.currency.getToken(token.id);
                        if (!currencyToken.decimals || currencyToken.decimals.lte('0')) {
                            this.currency.setTokenDecimals(token.id, new bifrost_number_1.default(await this.callErc20Decimals(token.address)));
                        }
                        if (token.sendAddress !== address) {
                            token.sendAddress = address;
                        }
                        if (token.handlerAddress !== address) {
                            token.handlerAddress = address;
                        }
                        marketTokens.push(token.id);
                    }
                }
                const tokens = network.tokens;
                const defaultNetwork = this.getNetwork();
                for (const token of tokens) {
                    if (marketTokens.indexOf(token.id) >= 0 || token.isComingSoon) {
                        continue;
                    }
                    const defaultNetworkToken = defaultNetwork.getToken(token.id);
                    if (defaultNetworkToken && defaultNetworkToken.address && defaultNetworkToken.isToken) {
                        let price;
                        try {
                            if ((defaultNetworkToken.pairTokens || []).length >= 1) {
                                const rpc = defaultNetworkToken.id.split('.')[0];
                                switch (rpc) {
                                    case 'uniswap':
                                        price = await this.uniswapRpc.getPairTokenPrice(defaultNetworkToken.address);
                                        break;
                                    default:
                                        price = await this.sushiswapRpc.getPairTokenPrice(defaultNetworkToken.address);
                                        break;
                                }
                            }
                            else {
                                price = await this.sushiswapRpc.getTokenPrice(defaultNetworkToken.address);
                            }
                        }
                        catch (error) {
                            console.log(defaultNetworkToken, error);
                        }
                        this.currency.setTokenPrice(token.id, new bifrost_number_1.default(price || '0'));
                        const currencyToken = this.currency.getToken(token.id);
                        if (!currencyToken.decimals || currencyToken.decimals.lte('0')) {
                            this.currency.setTokenDecimals(token.id, new bifrost_number_1.default(await this.callErc20Decimals(token.address)));
                        }
                    }
                    if (token.entryPointID) {
                        const entryPointAddress = network.getEntryPointAddress(token.entryPointID);
                        if (token.sendAddress !== entryPointAddress) {
                            token.sendAddress = entryPointAddress;
                        }
                        if (token.handlerAddress !== entryPointAddress) {
                            token.handlerAddress = entryPointAddress;
                        }
                    }
                }
                resolve(true);
            }
            catch (error) {
                if (error !== config_1.default.code.diffNetwork && error !== config_1.default.code.noResponse) {
                    console.log('syncTokens', error);
                }
                resolve(false);
            }
        });
    }
    getMethodArgumentValue(id) {
        return new Promise(async (resolve, reject) => {
            try {
                let result;
                switch (id) {
                    case 'blockNumber':
                        result = await this.callBlockNumber();
                        break;
                }
                resolve(result);
            }
            catch (error) {
                reject(error);
            }
        });
    }
    getMethodArgumentAppendValue(value, valueArgs) {
        let result = value;
        for (const valueArg of valueArgs) {
            switch (valueArg) {
                case 'hourLater':
                    const hourBlocks = Math.floor(config_1.default.MILLISECOND.PER_HOUR / this.getBlockTerm());
                    result += hourBlocks;
                    break;
                case 'dayLater':
                    const dayBlocks = Math.floor(config_1.default.MILLISECOND.PER_DAY / this.getBlockTerm());
                    result += dayBlocks;
                    break;
                case 'weekLater':
                    const weekBlocks = Math.floor(config_1.default.MILLISECOND.PER_WEEK / this.getBlockTerm());
                    result += weekBlocks;
                    break;
                case 'yearLater':
                    const yearBlocks = Math.floor(config_1.default.MILLISECOND.PER_YEAR / this.getBlockTerm());
                    result += yearBlocks;
                    break;
            }
        }
        return result;
    }
    connectWallet() {
        return new Promise(async (resolve) => {
            resolve(await this.callRpc.callRequestAccounts(this.getCurrenctNetworkID()) || []);
        });
    }
    callNetwork() {
        return new Promise(async (resolve) => {
            resolve(BiFi.parseNetwork(await this.callRpc.callNetwork(this.getCurrenctNetworkID())));
        });
    }
    callBlockNumber() {
        return new Promise(async (resolve) => {
            resolve(await this.callRpc.callBlockNumber(this.getCurrenctNetworkID()) || 0);
        });
    }
    callGasPrice() {
        return new Promise(async (resolve) => {
            resolve(await this.callRpc.callGasPrice(this.getCurrenctNetworkID()) || '0');
        });
    }
    callAccounts() {
        return new Promise(async (resolve) => {
            resolve(await this.callRpc.callAccounts(this.getCurrenctNetworkID()) || []);
        });
    }
    callTransactionReceipt(transactionHash) {
        return new Promise(async (resolve) => {
            resolve(await this.callRpc.callTransactionReceipt(this.getCurrenctNetworkID(), transactionHash));
        });
    }
    callBalance(address) {
        return new Promise(async (resolve) => {
            resolve(await this.callRpc.callBalance(this.getCurrenctNetworkID(), address) || '0');
        });
    }
    callErc20Balance(tokenAddress, userAddress, decimals) {
        return new Promise(async (resolve) => {
            if (!decimals) {
                decimals =
                    this.currency.getToken((this.getCurrenctNetwork().getTokenByAddress(tokenAddress) || {}).id).decimals.toNum()
                        || config_1.default.default.decimals;
            }
            resolve(await this.callRpc.callErc20Balance(this.getCurrenctNetworkID(), tokenAddress, userAddress, decimals) || '0');
        });
    }
    callErc20Allowance(tokenAddress, userAddress, targetAddress, decimals) {
        return new Promise(async (resolve) => {
            if (!decimals) {
                decimals =
                    this.currency.getToken((this.getCurrenctNetwork().getTokenByAddress(tokenAddress) || {}).id).decimals.toNum()
                        || config_1.default.default.decimals;
            }
            resolve(await this.callRpc.callErc20Allowance(this.getCurrenctNetworkID(), tokenAddress, userAddress, targetAddress, decimals) || '0');
        });
    }
    callErc20Decimals(tokenAddress) {
        return new Promise(async (resolve) => {
            resolve(await this.callRpc.callErc20Decimals(this.getCurrenctNetworkID(), tokenAddress) || '0');
        });
    }
    watchAsset(address, symbol, decimals = 18, image = '', type = 'ERC20') {
        return new Promise(async (resolve) => {
            resolve(await this.callRpc.watchAsset(this.getCurrenctNetworkID(), address, symbol, decimals, image, type) || false);
        });
    }
    addChain(chainId, chainName, rpcUrls = [], blockExplorerUrls, nativeCurrency, iconUrls) {
        return new Promise(async (resolve) => {
            resolve(await this.callRpc.addChain(this.getCurrenctNetworkID(), BiFi.parseChainID(chainId), chainName, rpcUrls, blockExplorerUrls, nativeCurrency, iconUrls)
                || false);
        });
    }
    switchChain(chainId) {
        return new Promise(async (resolve) => {
            resolve(await this.callRpc.switchChain(this.getCurrenctNetworkID(), BiFi.parseChainID(chainId))
                || false);
        });
    }
    switchAndAddChain(chainId, chainName, rpcUrls = [], blockExplorerUrls, nativeCurrency, iconUrls) {
        return new Promise(async (resolve) => {
            resolve(await this.callRpc.switchAndAddChain(this.getCurrenctNetworkID(), BiFi.parseChainID(chainId), chainName, rpcUrls, blockExplorerUrls, nativeCurrency, iconUrls)
                || false);
        });
    }
    static isValidAddress(address) {
        return address && web3_1.default.utils.isAddress(address);
    }
    static isAllowedNetwork(network) {
        const parsedNetwork = BiFi.parseNetwork(network);
        return config_1.default.networks.findIndex(configNetwork => BiFi.parseNetwork(configNetwork.id) === parsedNetwork) >= 0;
    }
    static parseChainID(chainId) {
        switch (`${chainId}`.toLowerCase()) {
            case '1':
            case '0x1':
            case 'main':
            case 'mainnet':
                chainId = '0x1';
                break;
            case '3':
            case '0x3':
            case 'ropsten':
                chainId = '0x3';
                break;
            case '4':
            case '0x4':
            case 'rinkeby':
                chainId = '0x4';
                break;
            case '5':
            case '0x5':
            case 'görli':
            case 'gorli':
            case 'goerli':
                chainId = '0x5';
                break;
            case '11155111':
            case '0xaa36a7':
            case 'sepolia':
            case 'sepolia-testnet':
            case 'ethereum-sepolia':
            case 'ethereum-sepolia-testnet':
                chainId = '0xaa36a7';
                break;
            case '84532':
            case '0x14a34':
            case 'base-sepolia':
            case 'base-sepolia-testnet':
                chainId = '0x14a34';
                break;
            case '421614':
            case '0x66eee':
            case 'arbitrum-sepolia':
            case 'arbitrum-sepolia-testnet':
                chainId = '0x66eee';
                break;
            case '42':
            case '0x2a':
            case 'kovan':
                chainId = '0x2a';
                break;
            case '56':
            case '0x38':
            case 'bsc':
            case 'bnb':
            case 'binance':
                chainId = '0x38';
                break;
            case '97':
            case '0x61':
            case 'bsc-test':
            case 'bnb-test':
            case 'binance-test':
                chainId = '0x61';
                break;
            case '43114':
            case '0xa86a':
            case 'ava':
            case 'avax':
            case 'avalanche':
                chainId = '0xa86a';
                break;
            case '43113':
            case '0xa869':
            case 'ava-test':
            case 'avax-test':
            case 'avalanche-test':
                chainId = '0xa869';
                break;
            case '8217':
            case '0x2019':
            case 'klay':
            case 'klaytn':
            case 'kaia':
                chainId = '0x2019';
                break;
            case '1001':
            case '0x3e9':
            case 'klay-test':
            case 'klaytn-test':
            case 'kaia-test':
            case 'kaia-kairos-test':
            case 'kairos-test':
                chainId = '0x3e9';
                break;
            case '3068':
            case '0xbfc':
            case 'bifrost':
                chainId = '0xbfc';
                break;
            case '49088':
            case '0xbfc0':
            case 'bifrost-test':
                chainId = '0xbfc0';
                break;
            case '4648':
            case '0x1228':
            case 'pilab':
            case 'pilab-test':
            case 'pilab-poa2':
                chainId = '0x1228';
                break;
            case '1337':
            case '0x539':
            case 'pilab-fork':
                chainId = '0x539';
                break;
            default:
                chainId = '0x1';
                break;
        }
        return chainId;
    }
    static parseNetwork(network) {
        switch (`${network}`.toLowerCase()) {
            case '1':
            case '0x1':
            case 'main':
            case 'mainnet':
                network = 'mainnet';
                break;
            case '3':
            case '0x3':
            case 'ropsten':
                network = 'ropsten';
                break;
            case '4':
            case '0x4':
            case 'rinkeby':
                network = 'rinkeby';
                break;
            case '5':
            case '0x5':
            case 'görli':
            case 'gorli':
            case 'goerli':
                network = 'goerli';
                break;
            case '11155111':
            case '0xaa36a7':
            case 'sepolia':
            case 'sepolia-testnet':
            case 'ethereum-sepolia':
            case 'ethereum-sepolia-testnet':
                network = 'sepolia';
                break;
            case '84532':
            case '0x14a34':
            case 'base-sepolia':
            case 'base-sepolia-testnet':
                network = 'base-sepolia';
                break;
            case '421614':
            case '0x66eee':
            case 'arbitrum-sepolia':
            case 'arbitrum-sepolia-testnet':
                network = 'arbitrum-sepolia';
                break;
            case '42':
            case '0x2a':
            case 'kovan':
                network = 'kovan';
                break;
            case '56':
            case '0x38':
            case 'bsc':
            case 'bnb':
            case 'binance':
                network = 'bsc';
                break;
            case '97':
            case '0x61':
            case 'bsc-test':
            case 'bnb-test':
            case 'binance-test':
                network = 'bsc-test';
                break;
            case '43114':
            case '0xa86a':
            case 'ava':
            case 'avax':
            case 'avalanche':
                network = 'avalanche';
                break;
            case '43113':
            case '0xa869':
            case 'ava-test':
            case 'avax-test':
            case 'avalanche-test':
                network = 'avalanche-test';
                break;
            case '8217':
            case '0x2019':
            case 'klay':
            case 'klaytn':
            case 'kaia':
                network = 'kaia';
                break;
            case '1001':
            case '0x3e9':
            case 'klay-test':
            case 'klaytn-test':
            case 'kaia-test':
            case 'kaia-kairos-test':
            case 'kairos-test':
                network = 'kaia-test';
                break;
            case '3068':
            case '0xbfc':
            case 'bifrost':
                network = 'bifrost';
                break;
            case '49088':
            case '0xbfc0':
            case 'bifrost-test':
                network = 'bifrost-test';
                break;
            case '4648':
            case '0x1228':
            case 'pilab':
            case 'pilab-test':
            case 'pilab-poa2':
                network = 'pilab-poa2';
                break;
            case '1337':
            case '0x539':
            case 'pilab-fork':
                network = 'pilab-fork';
                break;
            case 'ipfs':
                network = 'ipfs';
                break;
            default:
                network = config_1.default.default.network;
                break;
        }
        return network;
    }
}
exports.default = BiFi;
;
//# sourceMappingURL=BiFi.js.map